import {
  assertSportsbookHistoryDetail,
  assertSportsbookHistoryList,
} from '../contracts/sportsbookHistoryResponse.contract.js';

export class SportsbookHistoryApiError extends Error {
  constructor(message, response) {
    super(message);
    this.name = 'SportsbookHistoryApiError';
    this.response = response;
  }
}

export const getSportsbookHistoryErrorMessage = (source, fallback = '요청을 처리하지 못했습니다.') => {
  const response = source?.response || source;
  const candidates = [
    response?.data?.message,
    response?.error?.message,
    response?.data?.error?.message,
    typeof response?.error === 'string' ? response.error : '',
    typeof response?.data?.error === 'string' ? response.data.error : '',
    response?.message,
    source?.message,
  ];
  return candidates.find((value) => (
    typeof value === 'string'
    && value.trim() !== ''
    && value !== 'Error in response'
  )) || fallback;
};

const requireSuccessData = (response, signal) => {
  if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  if (response?.status !== true || response?.data === null || response?.data === undefined) {
    throw new SportsbookHistoryApiError(getSportsbookHistoryErrorMessage(response), response);
  }
  return response.data;
};

export const requestSportsbookHistoryPage = async ({ service, params, signal }) => {
  const response = await service.getHistory(params, { signal });
  return assertSportsbookHistoryList(requireSuccessData(response, signal));
};

export const requestSportsbookHistoryDetail = async ({ service, historyId, signal }) => {
  const response = await service.getHistoryDetail(historyId, { signal });
  return assertSportsbookHistoryDetail(requireSuccessData(response, signal));
};

export const requestSportsbookHistoryCancel = async ({ service, historyId, command, signal }) => {
  const response = await service.cancelHistory(historyId, command, { signal });
  return requireSuccessData(response, signal);
};

export const createSportsbookHistoryCancelCommand = (rowVersion, reason = '사용자 요청') => {
  const idempotencyKey = (typeof window === 'undefined' ? null : window.crypto?.randomUUID?.())
    || `sportsbook-history-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return {
    row_version: rowVersion,
    idempotency_key: idempotencyKey,
    reason,
  };
};

export const isStaleSportsbookHistoryCommandError = (error) => {
  const response = error?.response || error;
  const code = response?.error_code
    || response?.code
    || response?.error?.code
    || response?.data?.error_code
    || response?.data?.code
    || response?.data?.error?.code;
  return response?.httpStatus === 409
    || code === 'STALE_ROW_VERSION'
    || code === 'SPORTSBOOK_HISTORY_STALE_VERSION';
};
